// modals.js

const openModal = ($el) => {
  $el.classList.add('is-active');
};

const closeModal = ($el) => {
  $el.classList.remove('is-active');
};

const closeAllModals = () => {
  document.querySelectorAll('.modal').forEach(($modal) => {
    closeModal($modal);
  });
};

document.querySelectorAll('[data-toggle="modal"]').forEach(($trigger) => {
  const $target = document.getElementById($trigger.dataset.target);
  $trigger.addEventListener('click', () => {
    openModal($target);
  });
});

document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button').forEach(($close) => {
  const $target = $close.closest('.modal');
  $close.addEventListener('click', () => {
    closeModal($target);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeAllModals();
  }
});
